import React, {FC} from 'react';

import {cn} from '@bem-react/classname';
import {useThemeValue} from '@gravity-ui/uikit';
import {SERVICE_NAME} from 'common/constants';
import addQueryParams from 'ui/utils/addQueryParams';

import UserDropdown from '../UserDropdown';

import Logo from 'ui/assets/svg/logo.svg';

import './Header.scss';

const cnHeader = cn('Header');
const {
    routes: {adminUrl},
} = window.YC;

const headerAdminUrl = addQueryParams(adminUrl, {utm_campaign: 'header'});

const Header: FC = () => {
    const theme = useThemeValue();

    return (
        <header className={cnHeader()}>
            <div className={cnHeader('LogoSection')}>
                <a
                    href={headerAdminUrl}
                    aria-label={SERVICE_NAME}
                    lang="en"
                    className={cnHeader('LogoLink')}
                >
                    <Logo
                        width="180"
                        className={cnHeader('Logo', {theme})}
                        aria-hidden="true"
                        focusable="false"
                    />
                </a>
            </div>
            <div className={cnHeader('UserSection')}>
                <UserDropdown />
            </div>
        </header>
    );
};
export default Header;
